import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * What the partner pays now and from when. Nothing is ever charged at
 * purchase: the licence is invoiced with the partner's other services on the
 * 1st, so "due today" is always zero and the second line names the first
 * billing date the backend decided.
 */
export default function PaywallDueToday({ dueToday, billingStart, price }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:ProviderBilling:LicensePaywallModal' });

  return (
    <div
      className="flex flex-col gap-[10px] rounded-xl bg-brand-inkGrey-grey_0 px-[18px] py-md"
      data-testid="license-paywall-due"
    >
      <div className="flex items-baseline justify-between gap-sm">
        <span className="text-[15px] font-semibold text-brand-text-default">{t('due_today')}</span>
        <span className="text-[17px] font-bold text-brand-text-default" data-testid="license-paywall-due-today">
          {dueToday}
        </span>
      </div>
      {billingStart && (
        <div className="flex items-baseline justify-between gap-sm text-sm text-brand-inkGrey-grey_3">
          <span data-testid="license-paywall-billing-start">{t('from_date', { date: billingStart })}</span>
          <span>{t('price_per_month', { price })}</span>
        </div>
      )}
    </div>
  );
}
